<template>
	<div>
		<v-layout row wrap>
			<v-flex sm6>
				<v-flex text-xs-left xs12>
					<div>
						<div
							class="result-container employee"
							:class="{
								'item-text': true,
								'na-text': discussionItem.employeeItem.result == '-1',
								'green-text': discussionItem.employeeItem.result == '2',
								'amber-text': discussionItem.employeeItem.result == '1',
								'red-text': discussionItem.employeeItem.result == '0'
							}"
						>
							<h5>Employee</h5>
							<table>
								<tr>
									<td style="width: 1px;">
										<v-btn
											:class="{ 'item-btn': true, success: discussionItem.employeeItem.result == '2', warning: discussionItem.employeeItem.result == '1', error: discussionItem.employeeItem.result == '0', disabled: true }"
											fab
											small
										>
											<v-icon v-if="discussionItem.employeeItem.result != '-1'" style="font-size: 14px;">{{ getIcon(discussionItem.employeeItem.result) }}</v-icon>
											<span v-if="discussionItem.employeeItem.result == '-1'" style="font-size:9px;">n/a</span>
										</v-btn>
									</td>
									<td>{{ discussionItem.item.item }}</td>
								</tr>
							</table>
						</div>

						<div v-for="outcome in discussionItem.employeeItem.outcomes" :key="outcome.id" style="margin-left:20px;">
							<div class="result-container" :class="{ 'item-text': true, 'na-text': outcome.result == '-1', 'green-text': outcome.result == '2', 'amber-text': outcome.result == '1', 'red-text': outcome.result == '0' }">
								<table>
									<tr>
										<td style="width: 1px;">
											<v-btn slot="activator" :class="{ 'item-btn': true, success: outcome.result == '2', warning: outcome.result == '1', error: outcome.result == '0', disabled: true }" fab small>
												<v-icon style="font-size: 14px;">keyboard_arrow_right</v-icon>
											</v-btn>
										</td>

										<td>{{ outcome.outcome.outcome }}</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</v-flex>

				<v-flex xs12>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<table v-if="discussionItem.employeeItem.comment != null" class="comment" v-on="on">
								<tr>
									<td>
										<v-avatar size="36px">
											<img :src="getAvatar(employee.id)" alt="avatar" class="avatar-img" />
										</v-avatar>
									</td>
									<td>
										<v-subheader class="text-xs-left comment-text">{{ discussionItem.employeeItem.comment }}</v-subheader>
									</td>
								</tr>
							</table>
						</template>
						<span>Comment from {{ employee.fullName }}</span>
					</v-tooltip>
				</v-flex>
			</v-flex>

			<v-flex sm6 class="item-container reviewer">
				<v-flex text-xs-left xs12>
					<div>
						<div
							class="result-container"
							:class="{
								'item-text': true,
								'na-text': discussionItem.reviewerItem.result == '-1',
								'green-text': discussionItem.reviewerItem.result == '2',
								'amber-text': discussionItem.reviewerItem.result == '1',
								'red-text': discussionItem.reviewerItem.result == '0'
							}"
						>
							<h5>Reviewer</h5>

							<table role="presentation">
								<tr>
									<td style="width: 1px;">
										<v-btn
											:class="{ 'item-btn': true, success: discussionItem.reviewerItem.result == '2', warning: discussionItem.reviewerItem.result == '1', error: discussionItem.reviewerItem.result == '0', disabled: true }"
											fab
											small
										>
											<v-icon v-if="discussionItem.reviewerItem.result != '-1'" style="font-size: 14px;">{{ getIcon(discussionItem.reviewerItem.result) }}</v-icon>
											<span v-if="discussionItem.reviewerItem.result == '-1'" style="font-size:9px;">n/a</span>
										</v-btn>
									</td>
									<td style="width: 100%;">{{ discussionItem.item.item }}</td>
								</tr>
							</table>
						</div>

						<div v-for="outcome in discussionItem.reviewerItem.outcomes" :key="outcome.id" style="margin-left:20px;">
							<div class="result-container" :class="{ 'item-text': true, 'na-text': outcome.result == '-1', 'green-text': outcome.result == '2', 'amber-text': outcome.result == '1', 'red-text': outcome.result == '0' }">
								<table>
									<tr>
										<td style="width: 1px;">
											<v-btn slot="activator" :class="{ 'item-btn': true, success: outcome.result == '2', warning: outcome.result == '1', error: outcome.result == '0', disabled: true }" fab small>
												<v-icon style="font-size: 14px;">keyboard_arrow_right</v-icon>
											</v-btn>
										</td>

										<td>{{ outcome.outcome.outcome }}</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</v-flex>

				<v-flex xs12>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<table v-if="discussionItem.reviewerItem.comment != null" class="comment" v-on="on">
								<tr>
									<td>
										<v-avatar size="36px">
											<img :src="getAvatar(reviewer.id)" alt="avatar" class="avatar-img" />
										</v-avatar>
									</td>
									<td>
										<v-subheader class="text-xs-left comment-text">{{ discussionItem.reviewerItem.comment }}</v-subheader>
									</td>
								</tr>
							</table>
						</template>
						<span>Comment from {{ reviewer.fullName }}</span>
					</v-tooltip>

					<div v-if="showEditReviewerAnswerBtn" class="text-xs-right caption">
						<a href="#" @click.prevent="onEditItem(discussionItem.reviewerItem)">Edit Answer</a>
					</div>
				</v-flex>
			</v-flex>
		</v-layout>

		<v-layout row wrap style="margin-top:10px;">
			<v-textarea v-if="isDiscussion || notes" v-model="notes" :readonly="!isDiscussion" box label="Discussion Notes" rows="3" auto-grow :class="{ 'readonly-textarea': !isDiscussion }" :prepend-icon="!isDiscussion ? 'mdi-playlist-edit' : ''"></v-textarea>

			<div class="add-goal-panel">
				<v-btn v-if="isDiscussion" depressed small class="noPrint" @click="onAddGoal(discussionItem.id)">Create a Goal</v-btn>
			</div>
		</v-layout>

		<v-divider style="margin-bottom:20px;"></v-divider>
	</div>
</template>

<script>
	import avatarMixin from '@/mixins/avatarMixin';

	export default {
		props: {
			discussionItem: {
				required: true,
				type: Object
			},
			employee: {
				required: true,
				type: Object
			},
			reviewer: {
				required: true,
				type: Object
			},
			isDiscussion: {
				required: true,
				type: Boolean
			},
			loggedInEmployee: {
				required: true,
				type: Object
			}
		},
		data() {
			return {
				notes: this.discussionItem.notes,
				on: undefined
			};
		},
		watch: {
			notes(newVal, oldVal) {
				this.$emit('onNotesUpdated', { id: this.discussionItem.id, notes: newVal });
			}
		},
		mixins: [avatarMixin],
		computed: {
			showEditReviewerAnswerBtn() {
				return this.isDiscussion && (this.loggedInEmployee.isAdmin || this.loggedInEmployee.id === this.reviewer.id);
			}
		},
		methods: {
			onAddGoal() {
				this.$emit('onAddGoal');
			},
			onEditItem() {
				this.$emit('onEditItem', this.discussionItem.reviewerItem);
			},
			getIcon(result) {
				switch (result) {
					case -1:
						return 'radio_button_unchecked';
					case 0:
						return 'clear';
					case 1:
						return 'remove';
					case 2:
						return 'check';
					default:
						return 'keyboard_arrow_right';
				}
			}
		}
	};
</script>

<style scoped>
	.add-goal-panel {
		width: 100%;
		text-align: left;
		margin-top: -20px;
		margin-bottom: 15px;
	}
	.add-goal-panel.summary {
		width: 100%;
		text-align: left;
		margin-top: 0;
		margin-bottom: 0;
	}
	.comment-text {
		height: inherit;
	}
	.result-container {
		border-left-color: lightgray;
		padding-left: 10px;
		padding-right: 10px;
	}
	.traffic-light-options-container {
		padding: 5px;
		background-color: #fff;
	}
	.traffic-light-option {
		height: 30px;
		width: 30px;
	}
</style>
